import {AppointmentRequestConfigFragment} from '@/generated/graphql';

export const isDirectBooking = (
  config: AppointmentRequestConfigFragment | null | undefined
): boolean => {
  return (
    !config?.proposeSlots &&
    !!config?.autoRequestApproval &&
    !!config?.autoSlotSelection
  );
};
